import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DrinkComponent from './DrinkComponent'
import Grid from '@material-ui/core/Grid'
import _ from 'lodash'

export default class CategoryConsosComponent extends Component {
  static propTypes = {
    counter: PropTypes.bool,
    size: PropTypes.string,
    products: PropTypes.array.isRequired,
    addConso: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired
  }
  state = {
    expanded: false
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded })
  }
  render() {
    const { products, color, size } = this.props
    return (
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
        spacing={32}>
        {_.orderBy(products, 'order').map((item, index) => {
          return (
            <Grid item key={index}>
              <DrinkComponent
                color={color}
                item={item}
                size={size}
                addConso={this.props.addConso}
                counter={this.props.counter || false}
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Products/components/CategoryConsosComponent.js